import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { RuleInterface } from '@vendasta/automata';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { NoRules } from '../../common';

@Component({
  selector: 'automata-partner-trial-created-panel',
  imports: [CommonModule, TranslateModule, GalaxyFormFieldModule],
  templateUrl: './partner-trial-created-panel.component.html',
})
export class PartnerTrialCreatedPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  ngOnInit(): void {
    this.savingEnabled$.next(true);
  }

  isFormValid(): boolean {
    return true;
  }

  getBaseRules(): RuleInterface[] {
    return NoRules();
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }
}
